<template>
    <v-container>
        <v-row class="center">
            <v-card class="group-deal-container">
                <v-row class="center">
                    <h2>Group Deals</h2>
                </v-row>
                <v-row v-if="dealsChanged" class="end me-6">
                    <v-card @click="saveDeals" id="group-deal-save">
                        <v-icon>far fa-save</v-icon>
                    </v-card>
                </v-row>
                <v-row class="center">
                    <group-deal v-for="deal in tempDeals" :key="deal.id" @view-group-deal="viewDeal" :dealData="deal"></group-deal>
                    <v-card @click="showAddDealDialog" class="group-deal-card my-5 mx-3">
                        <v-img class="mx-5 mt-2" :src="addDealIcon" />
                        <span>Add Deal</span>
                    </v-card>
                </v-row>
            </v-card>
        </v-row>
        <group-deal-dialog :showDialog="dealDialog" :selectedDeal="selectedDeal"
            @add-deal="addDeal" @update-deal="updateDeal" @delete-deal="deleteDeal" @set-dialog-control="setDialogControl"></group-deal-dialog>
    </v-container>
</template>

<script>
import GroupDealItem from '../../../components/common/PromoListItem';
import AddGroupDealDialog from '../../../components/common/Business/AddGroupDealDialog';
import utils from '../../../utilities/utils';


export default {
    components: {
        "group-deal": GroupDealItem,
        "group-deal-dialog": AddGroupDealDialog
    },
    data: () => ({
        dealDialog: false,
        selectedDeal: null,
        initialDeals: {}
    }),
    created(){
        this.initialDeals = Object.assign(this.initialDeals, this.$store.state.tempGroupDeals);
    },
    methods: {
        showAddDealDialog(){
            this.selectedDeal = null;
            this.dealDialog = true;
        },
        updateDeal(deal){
            console.log('update-deal: ' + JSON.stringify(deal));
            this.$store.dispatch('UPDATE_GROUP_DEAL', deal);
        },
        saveDeals(){
            this.$store.dispatch('SAVE_GROUP_DEALS');
        },
        addDeal(deal){
            console.log('add-deal' + JSON.stringify(deal));
            this.$store.dispatch('ADD_GROUP_DEAL', deal);
        },
        setDialogControl(val){
            this.dealDialog = val;
        },
        deleteDeal(deal){
            this.$store.dispatch('DELETE_GROUP_DEAL', deal);
        },
        viewDeal(deal){
            this.selectedDeal = Object.assign({}, deal);
            this.dealDialog = true;
        }
    },
    computed: {
        tempDeals(){
            return this.$store.state.tempGroupDeals;
        },
        dealsChanged(){
            return utils.dealsHaveChanged(this.tempDeals, this.initialDeals);
        },
        addDealIcon(){
            return require('../../../assets/Add-Deal.svg');
        }
    }
}
</script>